import { render, staticRenderFns } from "./boxTransportationList.vue?vue&type=template&id=661176da"
import script from "./boxTransportationList.vue?vue&type=script&lang=js"
export * from "./boxTransportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports